import { UK_VAT_RATE_AS_DECIMAL } from "lib/constants";
import { ResponseVehicle } from "services/motorpoint/shortlist";
import { VehicleService } from "services/vehicle/vehicle";

const getCurrentSellingPrice = (vehicle: VehicleService.Vehicle | ResponseVehicle) => {
    const vehicleResponse = vehicle as ResponseVehicle;
    const vehicleFull = vehicle as VehicleService.Vehicle;

    return (vehicleFull?.Taxonomy?.IsCommercial ?? vehicleResponse?.IsCommercial)
        ? (vehicleFull?.CurrentPrice?.SalePrice?.BasicPrice ?? vehicleResponse?.CurrentPrice)
        : vehicleFull?.CurrentPrice?.SalePrice?.BasicPrice || vehicleResponse?.CurrentPrice
          ? (vehicleFull?.CurrentPrice?.SalePrice?.BasicPrice ?? vehicleFull?.CurrentPrice ?? 0) +
            (vehicleFull?.CurrentPrice?.SalePrice?.VATAmount ?? 0)
          : 0;
};

export default getCurrentSellingPrice;
